import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// Changes are for downgrading CRA from React 18 to React 17
// - SEE: https://dev.to/lowla/create-react-app-with-a-previous-version-of-react-4g03

const root = document.getElementById('root');

ReactDOM.render(
  <App />,
  root
);
